var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-header row"},_vm._l((_vm.fields),function(value,name){return _c('div',{staticClass:"col-sm-4"},[_c('b',[_vm._v(_vm._s(name)+":")]),_vm._v(" "+_vm._s(value)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }